/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash fad5f08910134e157cae983410d57c8b */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EstimateActions = "CHOOSE_OPTION" | "PROVIDE_USER" | "UPDATE_DATA" | "%future added value";
export type EstimateState = "CALCULATING_OPTIONS" | "COMPLETED" | "CREATED" | "GDPR_CLEANED" | "LEAD_DETAILS_NEEDED" | "NO_OPTIONS_AVAILABLE" | "OPTION_CHOICE_NEEDED" | "REJECTED" | "REJECTED_WITH_LEAD" | "SUPPORT_NEEDED" | "USER_NEEDED" | "VEHICLE_DETAILS_NEEDED" | "%future added value";
export type CarPriceEstimate2Input = {
    id?: string | null;
    action: EstimateActions;
    lead?: LeadInput | null;
    attribution?: AttributionInput | null;
    chosenOptionId?: string | null;
    data?: CarPriceEstimateDataInput | null;
};
export type LeadInput = {
    phoneNumber?: string | null;
    email?: string | null;
    givenNames?: string | null;
    lastName?: string | null;
    dateOfBirth?: string | null;
};
export type AttributionInput = {
    utmParams?: UTMParamsInput | null;
    testCohorts?: Array<TestingCohortInput> | null;
    featureName?: string | null;
    locationName?: string | null;
};
export type UTMParamsInput = {
    source: string;
    medium?: string | null;
    campaign?: string | null;
    term?: string | null;
    content?: string | null;
    adgroup?: string | null;
};
export type TestingCohortInput = {
    name: string;
    cohort: string;
};
export type CarPriceEstimateDataInput = {
    person?: CarPriceEstimatePersonInput | null;
    vehicle?: CarPriceEstimateVehicleInput | null;
};
export type CarPriceEstimatePersonInput = {
    dateOfBirth?: string | null;
    postcode?: string | null;
};
export type CarPriceEstimateVehicleInput = {
    registrationNumber?: string | null;
    make?: string | null;
    model?: string | null;
    year?: number | null;
    engineSize?: number | null;
};
export type useCarEstimateResultMutationVariables = {
    input: CarPriceEstimate2Input;
};
export type useCarEstimateResultMutationResponse = {
    readonly result: {
        readonly estimateResult: {
            readonly state: EstimateState;
            readonly " $fragmentRefs": FragmentRefs<"CarQuickEstimatesGbContainer_estimateResult">;
        };
    } | null;
};
export type useCarEstimateResultMutation = {
    readonly response: useCarEstimateResultMutationResponse;
    readonly variables: useCarEstimateResultMutationVariables;
};



/*
mutation useCarEstimateResultMutation(
  $input: CarPriceEstimate2Input!
) {
  result: getCarPriceEstimate2(input: $input) {
    estimateResult {
      state
      ...CarQuickEstimatesGbContainer_estimateResult
      id
    }
  }
}

fragment CarEstimatesProgressIndicator_estimateResult on CarEstimateResult {
  state
}

fragment CarQuickEstimatesGbContainer_estimateResult on CarEstimateResult {
  id
  state
  ...QuickEstimatesPersonalDetails_estimateResult
  ...QuickEstimatesAuthentication_estimateResult
  ...QuickEstimatesRejection_estimateResult
  ...QuickEstimatesSupportNeeded_estimateResult
  ...CarEstimatesProgressIndicator_estimateResult
  ...CarQuickEstimatesOptions_estimateResult
  ...CarQuickEstimatesVehicle_estimateResult
}

fragment CarQuickEstimatesOptions_estimateResult on CarEstimateResult {
  id
  assumptions
  options {
    ...QuickEstimatesModalOptionsCard_options
    product {
      __typename
      coverType
      frequency
      id
    }
    id
  }
}

fragment CarQuickEstimatesVehicleForm_estimateResult on CarEstimateResult {
  id
  data {
    vehicle {
      registrationNumber
      make
      model
      year
      engineSize
    }
  }
}

fragment CarQuickEstimatesVehicle_estimateResult on CarEstimateResult {
  ...CarQuickEstimatesVehicleForm_estimateResult
}

fragment HeaderPrice_price on Price {
  ...PriceString_price
}

fragment PriceString_price on Price {
  valueDecimal
  currency {
    isoCode
  }
}

fragment QuickEstimatesAuthentication_estimateResult on BaseEstimateResult {
  lead {
    isEmailAvailable
  }
  ...QuickEstimatesLoginForm_estimateResult
  ...QuickEstimatesRegisterForm_estimateResult
}

fragment QuickEstimatesCoverOption_option on EstimateOption {
  rate {
    ...PriceString_price
  }
  product {
    __typename
    frequency
    coverType
    id
  }
}

fragment QuickEstimatesLoginForm_estimateResult on BaseEstimateResult {
  lead {
    email
    isEmailAvailable
  }
}

fragment QuickEstimatesModalOptionsCard_options on EstimateOption {
  ...QuickEstimatesCoverOption_option
  id
  rate {
    ...HeaderPrice_price
  }
  product {
    __typename
    code
    frequency
    coverType
    id
  }
}

fragment QuickEstimatesPersonalDetails_estimateResult on BaseEstimateResult {
  id
}

fragment QuickEstimatesRegisterForm_estimateResult on BaseEstimateResult {
  lead {
    givenNames
    lastName
    phoneNumber
    email
    isEmailAvailable
    dateOfBirth
  }
}

fragment QuickEstimatesRejection_estimateResult on BaseEstimateResult {
  id
  state
  rejection {
    messageHtml
  }
}

fragment QuickEstimatesSupportNeeded_estimateResult on BaseEstimateResult {
  id
  state
  supportNeeded {
    messageHtml
    reason
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CarPriceEstimate2Input!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "messageHtml",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "useCarEstimateResultMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "result",
        "name": "getCarPriceEstimate2",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "GetCarPriceEstimate2Payload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimateResult",
            "storageKey": null,
            "args": null,
            "concreteType": "CarEstimateResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "CarQuickEstimatesGbContainer_estimateResult",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "useCarEstimateResultMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "result",
        "name": "getCarPriceEstimate2",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "GetCarPriceEstimate2Payload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimateResult",
            "storageKey": null,
            "args": null,
            "concreteType": "CarEstimateResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lead",
                "storageKey": null,
                "args": null,
                "concreteType": "Lead",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isEmailAvailable",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "givenNames",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "phoneNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dateOfBirth",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "rejection",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateResultRejection",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "supportNeeded",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateResultSupportNeeded",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "reason",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "assumptions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "options",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateOption",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "rate",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Price",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "valueDecimal",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currency",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Currency",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isoCode",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "frequency",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "coverType",
                        "args": null,
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "data",
                "storageKey": null,
                "args": null,
                "concreteType": "CarEstimateData",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vehicle",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CarEstimateVehicle",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "registrationNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "make",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "model",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "year",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "engineSize",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "useCarEstimateResultMutation",
    "id": null,
    "text": "mutation useCarEstimateResultMutation(\n  $input: CarPriceEstimate2Input!\n) {\n  result: getCarPriceEstimate2(input: $input) {\n    estimateResult {\n      state\n      ...CarQuickEstimatesGbContainer_estimateResult\n      id\n    }\n  }\n}\n\nfragment CarEstimatesProgressIndicator_estimateResult on CarEstimateResult {\n  state\n}\n\nfragment CarQuickEstimatesGbContainer_estimateResult on CarEstimateResult {\n  id\n  state\n  ...QuickEstimatesPersonalDetails_estimateResult\n  ...QuickEstimatesAuthentication_estimateResult\n  ...QuickEstimatesRejection_estimateResult\n  ...QuickEstimatesSupportNeeded_estimateResult\n  ...CarEstimatesProgressIndicator_estimateResult\n  ...CarQuickEstimatesOptions_estimateResult\n  ...CarQuickEstimatesVehicle_estimateResult\n}\n\nfragment CarQuickEstimatesOptions_estimateResult on CarEstimateResult {\n  id\n  assumptions\n  options {\n    ...QuickEstimatesModalOptionsCard_options\n    product {\n      __typename\n      coverType\n      frequency\n      id\n    }\n    id\n  }\n}\n\nfragment CarQuickEstimatesVehicleForm_estimateResult on CarEstimateResult {\n  id\n  data {\n    vehicle {\n      registrationNumber\n      make\n      model\n      year\n      engineSize\n    }\n  }\n}\n\nfragment CarQuickEstimatesVehicle_estimateResult on CarEstimateResult {\n  ...CarQuickEstimatesVehicleForm_estimateResult\n}\n\nfragment HeaderPrice_price on Price {\n  ...PriceString_price\n}\n\nfragment PriceString_price on Price {\n  valueDecimal\n  currency {\n    isoCode\n  }\n}\n\nfragment QuickEstimatesAuthentication_estimateResult on BaseEstimateResult {\n  lead {\n    isEmailAvailable\n  }\n  ...QuickEstimatesLoginForm_estimateResult\n  ...QuickEstimatesRegisterForm_estimateResult\n}\n\nfragment QuickEstimatesCoverOption_option on EstimateOption {\n  rate {\n    ...PriceString_price\n  }\n  product {\n    __typename\n    frequency\n    coverType\n    id\n  }\n}\n\nfragment QuickEstimatesLoginForm_estimateResult on BaseEstimateResult {\n  lead {\n    email\n    isEmailAvailable\n  }\n}\n\nfragment QuickEstimatesModalOptionsCard_options on EstimateOption {\n  ...QuickEstimatesCoverOption_option\n  id\n  rate {\n    ...HeaderPrice_price\n  }\n  product {\n    __typename\n    code\n    frequency\n    coverType\n    id\n  }\n}\n\nfragment QuickEstimatesPersonalDetails_estimateResult on BaseEstimateResult {\n  id\n}\n\nfragment QuickEstimatesRegisterForm_estimateResult on BaseEstimateResult {\n  lead {\n    givenNames\n    lastName\n    phoneNumber\n    email\n    isEmailAvailable\n    dateOfBirth\n  }\n}\n\nfragment QuickEstimatesRejection_estimateResult on BaseEstimateResult {\n  id\n  state\n  rejection {\n    messageHtml\n  }\n}\n\nfragment QuickEstimatesSupportNeeded_estimateResult on BaseEstimateResult {\n  id\n  state\n  supportNeeded {\n    messageHtml\n    reason\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '739a3ff1b6cfd67d09789efcae3f966c';
export default node;
